import React, {useCallback} from 'react';
import Button from "@/components/form/Button.tsx";
import {createPortal} from "react-dom";


export default function Modal({
    id,
                                  confirmLoading,
                                  onOk,
                                  onCancel,
    submitBtnClass,
                                  okText = "Submit",
                                  cancelText = "Cancel",
                                  title,
                                  onSubmit,
                                  children,
                                  disabled,
                              }:{
    id: string,
    confirmLoading?: boolean,
    submitBtnClass?: string,
    onOk?: (e: any) => void,
    onCancel?: (e: any) => void,
    onClose?: (e: any) => void,
    okText?: string,
    cancelText?: string,
    title?: string,
    visible?: boolean,
    onSubmit?: (e: any) => void,
    children: React.ReactNode,
    disabled?: boolean,
                              }) {
    const submitted = useCallback((e) => {
        if (e) {
            if ('preventDefault' in e) {
                e.preventDefault()
            }
            if ('stopPropagation' in e) {
                e.stopPropagation()
            }
        }
        if (onSubmit) {
            onSubmit(e)
        } else if (onOk) {
            onOk(e)
        } else if (onCancel) {
            onCancel(e)
        }

    }, [onSubmit, onOk, onCancel])
    return (
        createPortal(<dialog id={id} className="modal">
            <div className="modal-box">
                <Form onSubmit={submitted}>
                    <h3 className="font-semibold text-lg mb-4">{title}</h3>
                    {
                        children
                    }
                    <div className="modal-action flex justify-end items-center gap-2">
                        <form method="dialog">
                            {/* if there is a button in form, it will close the modal */}
                            <button className="btn btn-ghost">{cancelText}</button>
                        </form>
                        {
                            onOk || onSubmit || onCancel ?
                            <Button
                                disabled={disabled}
                                loading={confirmLoading}
                                className={`${submitBtnClass || 'btn btn-primary'}`} onClick={onOk}>{okText}</Button> : null
                        }
                    </div>
                </Form>
            </div>
        </dialog>, document.body)
    )
}

function Form({onSubmit, children}) {
    return onSubmit ? <form onSubmit={onSubmit}>{children}</form> : children
}
